import { useDocumentTitleEntity } from '@components/DocumentTitle'
import { useAppSelector } from '@store/hooks'
import { selectMembershipProfileById } from '@store/membership/MembershipProfileReducer'
import { useParams } from 'react-router-dom'
import MembershipProfileSectionsLayout from './MembershipProfileSectionsLayout'

const MembershipProfileLayout = () => {
  const { membershipProfileId } = useParams<{ membershipProfileId: string }>()
  const membershipProfile = useAppSelector(
    selectMembershipProfileById(Number(membershipProfileId))
  )
  useDocumentTitleEntity(
    [membershipProfile?.firstName, membershipProfile?.lastName]
      .filter(Boolean)
      .join(' ') || undefined
  )

  return <MembershipProfileSectionsLayout id={Number(membershipProfileId)} />
}

export default MembershipProfileLayout
